function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 578 584",
    style: {
      enableBackground: 'new 0 0 578 584'
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M376.6 134.8c-53.6 0-97.8-34.8-165.2-34.8-25 0-47.3 4.4-68 12 2.9-7.5 4.1-15.5 3.6-23.6C145.1 60 121.8 37.2 93.3 36 61.3 34.7 35 60.3 35 92c0 19 9.5 35.8 24 45.9V524c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V131.9c0-23.4-24.3-38.9-45.5-29-34.2 16-76.3 31.9-116.8 31.9z",
    style: {
      fill: 'none',
      stroke: '#000',
      strokeWidth: 55,
      strokeMiterlimit: 10
    }
  }));
};
export default SvgComponent;